export const services = [
  {
    image: "Free Shipping",
    title: "From all orders over $100",
    tagline: "images/service.png",
  },
  {
    image: "Daily Surprise Offers",
    title: "Save up to 25% off",
    tagline: "images/service-02.png",
  },
  {
    image: "Support 24/7",
    title: "Shop with an expert",
    tagline: "images/service-03.png",
  },
  {
    image: "Affordable Prices",
    title: "Get Factory Default Price",
    tagline: "images/service-04.png",
  },
  {
    image: "Secure Payments",
    title: "100% Protected Payments",
    tagline: "images/service-05.png",
  },
];
